"use client"

import { WifiZero } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `WifiZeroIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const WifiZeroIcon = component(Icon)({ as: WifiZero })
